import * as React from 'react';
import { useEffect, useState } from 'react';
import styled from '@emotion/styled';

export interface SidebarWidgetProps {
  show: boolean;
  width: number;
  className?: any;
  hidden?: () => any;
}

const TIMEOUT = 220;

export const SidebarWidget: React.FC<React.PropsWithChildren<SidebarWidgetProps>> = (props) => {
  const [eventsEnabled, setEventsEnabled] = useState(false);
  useEffect(() => {
    if (props.show) {
      setEventsEnabled(false);
      setTimeout(() => {
        setEventsEnabled(true);
      }, TIMEOUT);
      return () => {
        setTimeout(() => {
          props.hidden?.();
        }, TIMEOUT);
      };
    }
  }, [props.show]);
  return (
    <S.Container enabled={eventsEnabled} className={props.className} _width={props.show ? props.width : 0}>
      <S.Inner _width={props.width}>{props.children}</S.Inner>
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div<{ _width: number; enabled: boolean }>`
    transition: min-width ${(p) => TIMEOUT}ms ease-out;
    min-width: ${(p) => p._width}px;
    background: ${(p) => p.theme.layout.sidebar_background};
    overflow: hidden;
    pointer-events: ${(p) => (p.enabled ? 'all' : 'none')};
  `;

  export const Inner = styled.div<{ _width: number }>`
    min-width: ${(p) => p._width}px;
    height: 100%;
  `;
}
